import { css } from 'styled-components'

export const theme = {
  maxWidth: '961px',
  color: {
    primaryColor: '#6EC9BE',
    primaryColorRGB: '110, 201, 190',
    secondaryColor: '#34B2A3',
    tertiaryColor: '#0D7669',
    fourthColor: '#4F8680',
    textColor: '#424242',
    offWhite: '#FFFFFF',
    success: '#3A7523',
    error: '#C90813',
    warning: '#F5A952',
    grey: '#A9A9A9',
    lightGrey: '#6A6C6A',
    lightBlack: '#2B2B2B',
    paleBlack: '#A3A3A3',
    paleGray: '#C9C9C9',
    lightPaleGrey: '#EFEFEF',
    offGray: '#f6f5f5',
    lightGreyRGB: '208, 208, 208',
    greyNormal: '#787878',
    lightGray: '#979797',
    greenPrimary: '#34B2A5',
  },
  shadow: {
    selectShadow: '0 0 20px',
  },
  fonts: {
    family: {
      normal: 'printAble4u',
    },
    style: {
      extraLight: '200',
      light: '300',
      regular: '400',
      medium: '600',
      semiBold: '600',
      bold: '800',
    },
    size: {
      heading: '56px',
      subHeading: '48px',
      title: '40px',
      subTitle: '30px',
      extraNormal: '24px',
      normal: '22px',
      small: '18px',
      label: '16px',
      // heading: '56px',
      // subHeading: '48px',
      // title: '40px',
      // subTitle: '30px',
      // extraNormal: '20px',
      // normal: '18px',
      // small: '16px',
      // label: '14px',
    },
  },
  zIndex: {
    // the max z-index is 100, modal have it and is set in index.css
    dropdown: 2,
    menuList: 100,
    modal: 200,
  },
}

export const screenSize = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  mobileXL: 570,
  tabletS: 640,
  tabletM: 768,
  tablet: 961,
  laptop: 1024,
  laptopL: 1440,
  laptopXL: 1680,
  desktop: 2560,
}

export const media = Object.keys(screenSize).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media only screen and (max-width: ${screenSize[label]}px) {
      ${css(...args)}
    }
  `

  return acc
}, {})

export const minMedia = Object.keys(screenSize).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media only screen and (min-width: ${screenSize[label]}px) {
      ${css(...args)}
    }
  `

  return acc
}, {})

export default theme



// WEBPACK FOOTER //
// ./src/styles/_variables.js